
export const isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      try {
        // SD-6401: Added a fix to check if the chat page is opened in Safari browser on iOS devices
        // in the desktop view mode.
        const userAgent = navigator.userAgent || ""; // Fallback to empty string if userAgent is undefined
        const maxTouchPoints = navigator.maxTouchPoints || 0; // Fallback to 0 if maxTouchPoints is undefined
        const isAppleDevice = userAgent.toLowerCase().includes("macintosh");
        const isTouchScreen = maxTouchPoints >= 1;
        return navigator.userAgent.match(/iPhone|iPod/i) || (isAppleDevice && isTouchScreen);
      } catch (error) {
        return false; // if navigator is not defined
      }
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};
